(
    // This framework can be used in a similar fashion to the .NET INotifyPropertyChanged framework.  To use it, you will extend Observable.
    // When initializing an instance, you can load whatever processsing you want to happen when a property changes into the observers collection
    // in the form of a function.  Then, whenever a new change happens, you create an Event() to indicate that a new change is happening, and then
    // call Notify() on yourself with that event.  This will notify all observers (via calling that function) that a change has happened and 
    // provide the Event so the observer can decide if they have processed this event already or not.
    function (skyward, $, undefined) {
        skyward.observable = skyward.observable || {};

        var eventCounter = 0;
        skyward.observable.Event = function (eventID)
        {
            eventID = eventID || eventCounter++;
            this.EventID = eventID;
        };
        
        skyward.observable.Observable = function () { };
        skyward.observable.Observable.prototype.observers = {}; // function(observable, event)
        skyward.observable.Observable.prototype.notifying = []; // List of events the element is currently notifying for, to prevent infinite loops of notifying back and forth.
        skyward.observable.Observable.prototype.Initialize = function ()
        {
            // Inherited types must call this in their constructor so the references to these things aren't shared.
            this.observers = {};
            this.notifying = [];
        }
        skyward.observable.Observable.prototype.notify = function (propertyName, eventToken)
        {
            eventToken = eventToken || new Event();
            this.notifying.push(eventToken);

            if (this.observers.hasOwnProperty(propertyName))
            {
                for (var i = 0; i < this.observers[propertyName].length; i++) {
                    this.observers[propertyName][i](eventToken);
                }
            }
        };

        // An implementation of an observable can use this method to tell whether or not a given Event has already
        // been processed-- for example, if the observable is observing another observable, the function used to observe
        // can use this to see if this has already handled a given change event.
        skyward.observable.Observable.prototype.eventProcessed = function (eventToken)
        {
            for (var i = 0; i < this.notifying.length; i++)
            {
                if (this.notifying[i].EventID == eventToken.EventID)
                {
                    return true;
                }
            }
            return false;
        };
    }(window.skyward = window.skyward || {}, window.jQuery)
);